import request from "@/utils/request";

export function getDetail(data) {
  return request({
    url: "/report/detailSec?id=" + data.id + "&accountId=" + data.accountId,
    method: "get",
    onUploadProgress: function (e) {
      // console.log('e:',e);
    }

  });
}
export function getPosterUrl(data) {
  return request({
    url: "/user/getPosterUrl?id=" + data.id,
    method: "get",
    onUploadProgress: function (e) {
      // console.log('e:',e);
    }

  });
}



// /c/report/detailSec?id=1845406824148307970
